import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import {
  Trash3Fill,
  PlusCircleFill,
  HandThumbsUp,
} from "react-bootstrap-icons";
import { Modal } from "react-bootstrap";
import CroppingModal from "../../components/Cropping Modal/CroppingModal";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomDatePicker from "../../components/CustomDatePicker/CustomDatePicker";
import InputField from "../../components/InputField/InputField";
import PageHeader from "../../components/PageHeader/PageHeader";
import encrypt from "../../utils/helpers/encrypt";
import { validateImageFile } from "../../utils/helpers/validateFileUpload";
import { useNavigate } from "react-router-dom";
import { showLoader, hideLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import { showToast, hideToast } from "../../store/Toast/toast.slice";
import { FaCalendarAlt } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./QuizData.scss";

export interface Quiz {
  closeDate: number | Date;
  folder_id?: number;
  id: number;
  folder_name: string;
  title: string;
  description: string;
  folderImg: string;
  status?: number;
  show_result?: number;
  isTrainingQuiz: 0 | 1;
}

interface QuizPayload {
  folder_name: string;
  closeDate?: string;
  id?: number;
  isTrainingQuiz?: 0 | 1;
  description?: string;
}

const QuizData = () => {
  const navigate = useNavigate();
  const cmpMounted = useRef(false);
  const [data, setData] = useState<Quiz[]>([]);
  const [showCroppingModal, setShowCroppingModal] = useState(false);
  const [folder_name, setFolder_name] = useState("");
  const [folderImg, setFolderImg] = useState<{ value: any; src: string }>({
    value: null,
    src: "",
  });
  const [closeDate, setCloseDate] = useState<Date | null>(new Date());
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentItemId, setCurrentItemId] = useState<number | null>(null);
  const [imageChanged, setImageChanged] = useState(false);
  const [originalData, setOriginalData] = useState<QuizPayload | null>(null);
  const [isChecked, setIsChecked] = useState(false);
  const [description, setDescription] = useState<string>("");
  const [filteredData, setFilteredData] = useState<Quiz[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [filterType, setFilterType] = useState<"all" | "training" | "quiz">(
    "quiz"
  );
  const [closeDateError, setCloseDateError] = useState("");
  const dispatch = useAppDispatch();

  const handleIconClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    fetchQuizData();
  }, []);

  const fetchQuizData = async () => {
    try {
      dispatch(showLoader("Loading Data..."));
      const response = await postDetails(APIList.GET_ALL_QUIZ_FOLDER_NAME, {});
      const mappedData = response.data.map((item: any) => ({
        ...item,
        status: item.is_active,
      }));
      const filtered = mappedData.filter(
        (item: { isTrainingQuiz: number }) => item.isTrainingQuiz === 0
      );
      setData(mappedData);
      setFilteredData(filtered);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleShowModal = () => {
    setFolder_name("");
    setFolderImg({ value: null, src: "" });
    setCloseDate(null);
    setIsEditing(false);
    setIsEditing(false);
    setImageChanged(false);
    setCurrentItemId(null);
    setIsChecked(false);
    setShowModal(true);
    setErrorMessage("");
    setDescription("");
  };

  const handleCloseModal = () => setShowModal(false);

  const handleFolderChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // if (/^[A-Za-z0-9\s]*$/.test(value)) {
    setFolder_name(e.target.value);
    // }
  };
  const handleDescriptionChange = (e: ChangeEvent<HTMLInputElement>) => {
    setDescription(e.target.value);
  };

  const handleCoverImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const validation = validateImageFile(file);
    if (!validation.valid) {
      dispatch(showToast(validation.message));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    const maxSize = 11 * 1024 * 1024;
    if (file.size > maxSize) {
      // setErrorMessage(
      //   "File size exceeds the 10MB limit. Please upload a smaller file."
      // );
      dispatch(showToast(        "File size exceeds the 10MB limit. Please upload a smaller file."
      ));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    setFolderImg({
      value: file,
      src: URL.createObjectURL(file),
    });
    setShowCroppingModal(true);
    setImageChanged(true);
  };

  const handleCrop = (croppedImage: string) => {
    setFolderImg((prev) => ({ ...prev, src: croppedImage }));
    setShowCroppingModal(false);
  };

  const removeImage = () => {
    setFolderImg({ value: null, src: "" });
    setImageChanged(true);
  };

  const handleCancelCrop = () => {
    // Close the cropping modal without setting the image
    // setFolderImage({ value: null, src: "" }); // Reset the folder image
    setFolderImg((prev) => ({ ...prev, value: null, src: "" }));
    setShowCroppingModal(false); // Close the cropping modal
  };

  const submitDetails = async (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();

    if (!isEditing && !folderImg.value) {
      // setErrorMessage("Please upload an Image.");
      dispatch(showToast("Please upload an Image."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    if (!folder_name) {
      // setErrorMessage("Please fill in all Folder Name.");
      return;
    }

    if (!isChecked && !closeDate) {
      // setCloseDateError("Please fill the Close Date.");
      dispatch(showToast("Please fill the Close Date."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }
    setCloseDateError("");

    const formattedCloseDate = closeDate?.toISOString();
    const trimmedFolderName = folder_name.trim();
    const formData = new FormData();

    if (imageChanged && folderImg.value) {
      formData.append("folderImg", folderImg.value);
    }

    const payload: QuizPayload = {
      folder_name: trimmedFolderName,
      closeDate: formattedCloseDate,
      // description: description.trim(),
      isTrainingQuiz: isChecked ? 1 : 0,
    };

    if (!isChecked) {
      payload.description = description.trim();
    } else {
      delete payload.description;
    }

    // console.log("PAYLOAD", payload)

    if (isEditing && currentItemId !== null && originalData) {
      const noChanges =
        originalData.folder_name === folder_name &&
        originalData.closeDate === formattedCloseDate &&
        originalData.description === description &&
        !imageChanged;

      if (imageChanged && !folderImg.value) {
        setErrorMessage("Please upload an Image.");
        return;
      }

      if (noChanges) {
        dispatch(showToast("No Changes Done."));
        setTimeout(() => dispatch(hideToast()), 3000);
        setShowModal(true);
        return;
      }

      payload.id = currentItemId;
    }

    formData.append("data", encrypt(payload));

    try {
      let response;

      if (isEditing && currentItemId !== null) {
        response = await postMultipartDetails(
          APIList.EDIT_QUIZ_FOLDER_NAME,
          formData
        );
        if (response.statusCode === 200) {
          dispatch(showToast("Updated Successfully."));
          setShowModal(false);
          fetchQuizData();
          setErrorMessage("");
        } else {
          dispatch(showToast(`Failed to Update: ${response.message}`));
        }
      } else {
        response = await postMultipartDetails(
          APIList.ADD_QUIZ_FOLDER_NAME,
          formData
        );
        if (response.statusCode === 200) {
          dispatch(showToast("Added Successfully."));
          setFolder_name("");
          setFolderImg({ value: null, src: "" });
          setCloseDate(null);
          setShowModal(false);
          fetchQuizData();
          setErrorMessage("");
        } else {
          dispatch(showToast(`Failed to Add: ${response.message}`));
        }
      }
    } catch (error) {
      console.error("Error submitting details:", error);
    } finally {
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  };

  // const editItem = (item: Quiz) => {
  //   setFolder_name(item.folder_name);
  //   setFolderImg({ value: null, src: item.folderImg });
  //   setCloseDate(item.closeDate ? new Date(item.closeDate) : null);
  //   setDescription(item.description || "");
  //   setIsEditing(true);
  //   setCurrentItemId(item.id);
  //   setOriginalData({
  //     folder_name: item.folder_name,
  //     closeDate: item.closeDate ? item.closeDate.toString() : "",
  //     description: item.description,
  //   });
  //   setShowModal(true);
  //   setErrorMessage("");
  //   setImageChanged(false);
  // };

  const editItem = (item: Quiz) => {
    setFolder_name(item.folder_name);
    setFolderImg({ value: null, src: item.folderImg });
    setCloseDate(item.closeDate ? new Date(item.closeDate) : null);
    setDescription(item.description || "");
    setIsChecked(item.isTrainingQuiz === 1);
    setIsEditing(true);
    setCurrentItemId(item.id);
    setOriginalData({
      folder_name: item.folder_name,
      closeDate: item.closeDate ? item.closeDate.toString() : "",
      description: item.description,
    });
    setShowModal(true);
    setErrorMessage("");
    setImageChanged(false);
  };

  const deleteItemById = async (item: Quiz) => {
    try {
      const response = await postDetails(APIList.DELETE_QUIZ_FOLDER_NAME, {
        id: item.id,
      });

      if (response.status === "Failed") {
        console.log("Cannot delete folder");
        return;
      }

      setFilteredData((prevData) =>
        prevData.filter((row) => row.id !== item.id)
      );
      // console.log("Folder deleted");
      dispatch(showToast("Deleted Succesfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Error deleting folder:", error);
    }
  };

  const toggleStatus = async (item: Quiz) => {
    try {
      const newStatus = item.status === 1 ? 0 : 1;
      const response = await postDetails(APIList.CHANGE_QUIZ_FOLDER_STATUS, {
        id: item.id,
        is_active: newStatus,
      });

      if (response.status === "Failed") {
        console.log("Cannot update status");
        return;
      }

      setFilteredData((prevData) =>
        prevData.map((row) =>
          row.id === item.id ? { ...row, status: newStatus } : row
        )
      );
      dispatch(showToast("Status Successfully Updated."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const toggleResult = async (item: Quiz) => {
    try {
      const newToggle = item.show_result === 1 ? 0 : 1;
      const response = await postDetails(APIList.CHANGE_QUIZ_FOLDER_RESULT, {
        id: item.id,
        show_result: newToggle,
      });

      if (response.status === "Failed") {
        console.log("Cannot update status");
        return;
      }

      setFilteredData((prevData) =>
        prevData.map((row) =>
          row.id === item.id ? { ...row, show_result: newToggle } : row
        )
      );
      dispatch(showToast("Status Successfully Updated."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Error updating result:", error);
    }
  };

  const handleCheckboxChange = (ev: any) => {
    setIsChecked(ev.target.checked);
  };

  const handleCancel = () => {
    setFolder_name("");
    setFolderImg({ value: null, src: "" });
    setCloseDate(null);
    setShowModal(false);
  };

  const handleCloseDateChange = (date: Date | null) => {
    setCloseDate(date);
    setIsOpen(false);
  };

  const redirect = () => {
    navigate("/quiz/AddQuiz");
  };

  const handleViewQuiz = (item: Quiz) => {
    const id = item.id;
    if (id) {
      navigate('/quiz/detail', { state: { id: id } });
      // navigate(`/quiz/detail`);
    } else {
      console.error("ID is undefined or item is not properly structured.");
    }
  };

  const columns: TableColumn[] = (() => {
    if (filterType === "quiz") {
      return [
        {
          key: "folder_name",
          label: "Folder Name",
          sortable: true,
          dataType: "string",
        },
        { key: "folderImg", label: "Folder Image", dataType: "image" },
        {
          key: "",
          label: "Quiz Count",
          dataType: "button",
          button: {
            label: (item) => `View (${item.quizCount || 0})`,
            onClick: handleViewQuiz,
          },
        },
        { key: "show_result", label: "Show Result", dataType: "toggle" },
      ];
    } else if (filterType === "training") {
      return [
        {
          key: "folder_name",
          label: "Folder Name",
          sortable: true,
          dataType: "string",
        },
        { key: "folderImg", label: "Folder Image", dataType: "image" },
        {
          key: "",
          label: "Quiz Count",
          dataType: "button",
          button: {
            label: (item) => `View (${item.quizCount || 0})`,
            onClick: handleViewQuiz,
          },
        },
        { key: "trainingName", label: "Training Name", dataType: "string" },
        { key: "show_result", label: "Show Result", dataType: "toggle" },
      ];
    }
    return [];
  })();

  const handleQuizFilter = () => {
    const filtered = data.filter((item) => item.isTrainingQuiz === 0);
    setFilteredData(filtered);
    setFilterType("quiz");
  };

  const handleTrainingQuizFilter = () => {
    const filtered = data.filter((item) => item.isTrainingQuiz === 1);
    setFilteredData(filtered);
    setFilterType("training");
  };

  const buttons = [
    {
      label: "Select Type",
      theme: "warning text-white",
      dropdown: [
        {
          label: "Training Quiz",
          onClick: handleTrainingQuizFilter,
        },
        {
          label: "Quiz",
          onClick: handleQuizFilter,
        },
      ],
    },
    {
      label: "Add Quiz Folder",
      theme: "warning",
      icon: <PlusCircleFill />,
      onClick: handleShowModal,
    },
    {
      label: "Add Quiz",
      theme: "danger",
      icon: <PlusCircleFill />,
      onClick: redirect,
    },
  ];

  return (
    <div>
      <PageHeader buttons={buttons} />
      <CommonTable<Quiz>
        data={filteredData}
        columns={columns}
        onEdit={editItem}
        onDelete={deleteItemById}
        onStatusToggle={toggleStatus}
        onToggle={toggleResult}
        pagination={true}
        rowsPerPage={10}
        actions={{
          view: false,
          edit: true,
          delete: true,
          checkbox: true,
          status: true,
          showModal: false,
        }}
      />
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditing ? "Edit Quiz Folder" : "Add New Quiz Folder"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )}
          <form onSubmit={submitDetails}>
            <div className="input-wrapper height-50px">
              <InputField
                name="folderName"
                label="Folder Name"
                type="text"
                value={folder_name}
                placeholder="Enter Folder Name"
                maxLength={50}
                required={true}
                onChangeInput={handleFolderChange}
              />
              <div className="character-counter">
                {folder_name.length}/{50}
              </div>
            </div>

            { !isEditing && (<div className="mt-4 mb-4">
              <span className="d-flex gap-1">
                <input
                  type="checkbox"
                  name="isTraining"
                  id="isTraining"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="isTraining" className=" font-12 weight-500">
                  <span>Is it a Training Quiz?</span>
                </label>
              </span>
            </div>)}

            {/* Only show Description and Close Date fields when isTrainingQuiz is 0 */}
            {!isChecked && (
              <>
                <div className="input-wrapper height-50px">
                  <InputField
                    name="description"
                    label="Description"
                    type="text"
                    value={description}
                    placeholder="Enter Description"
                    maxLength={250}
                    required={true}
                    onChangeInput={handleDescriptionChange}
                  />
                  <div className="character-counter">
                    {description.length}/{250}
                  </div>
                </div>

                <label
                  htmlFor="closeDate"
                  className="weight-500"
                  style={{
                    display: "block",
                    marginBottom: "5px",
                    fontSize: "12px",
                  }}
                >
                  Close Date<span style={{ color: "red" }}>*</span>
                </label>
                <div className="date-picker-container height-50px mb-4">
                  <DatePicker
                    selected={closeDate}
                    onChange={handleCloseDateChange}
                    dateFormat="MMMM d, yyyy"
                    className={`mf-admin-inputfield`}
                    placeholderText="Select Date"
                    minDate={new Date()}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    onKeyDown={(e) => e.preventDefault()}
                    // required={true}
                    isClearable={true}
                  />
                  { closeDateError && <span className="font-12 error-text">{closeDateError}</span> }
                </div>
              </>
            )}

            <div className="upload-information mb-4">
              <p className="font-14 mb-4 text-danger fw-bold">
                Uploads must be JPG / JPEG / PNG
                <span style={{ color: "red", fontWeight: "bold" }}>*</span>
              </p>
              <div className="mb-2">
                <div className="upload-image-wrapper d-flex flex-column">
                  {folderImg.src && (
                    <>
                      {/* <span
                        className="remove-image-btn font-14 cursor-pointer"
                        onClick={removeImage}
                      >
                        Remove
                      </span> */}
                      <img
                        src={folderImg.src}
                        alt="video-challenge-image"
                        width={150}
                      />
                    </>
                  )}
                </div>
              </div>
              <label htmlFor="photo">
                <div className="upload-btn-wrapper font-14 d-flex align-items-center justify-content-center gap-1">
                  <i className="fa-regular fa-image"></i>
                  <span>
                    {folderImg.src ? "Change Photo" : "Upload Folder Image"}
                  </span>
                </div>
              </label>
              <InputField
                type="file"
                name="photo"
                id="photo"
                value={""}
                className="d-none"
                onChangeInput={handleCoverImageChange}
              />
            </div>
            <div className="add-video-challenge-btn-bottom d-flex flex-column-reverse flex-md-row align-items-md-center justify-content-md-center gap-3 mb-5">
              <CustomButton theme="red" size="md" onClick={handleCancel}>
                Cancel
              </CustomButton>
              <CustomButton theme="yellow" size="md" type="submit">
                Submit
              </CustomButton>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {/* Cropping Modal */}
      {folderImg.value && (
        <CroppingModal
          show={showCroppingModal}
          handleClose={() => setShowCroppingModal(false)}
          image={folderImg.src}
          onCrop={handleCrop}
          onCancel={handleCancelCrop}
        />
      )}
    </div>
  );
};

export default QuizData;
